<template>
  <LoginWrapper>
    <div class="box">
      <div class="box_title">
        <!-- <h2>고객님의 캠퍼스북 계정을 찾았습니다.</h2> -->
        <h2>고객님의 계정을 찾았습니다.</h2>
      </div>
      <ul class="form_wrap">
        <li class="text_wrap">
          <!-- 일반 계정 - SNS 연결 없음 -->
          <p v-if="loginId && providers.length === 0" class="guide_txt">
            아이디 확인 후 로그인을 해주세요.
          </p>
          <!-- 일반 계정 - SNS 연결 있음 -->
          <p v-else-if="loginId && providers" class="guide_txt">
            해당 계정은 SNS 계정({{ userProviders }})과 연결되어 있습니다.
            <br />
            아이디 확인 후 로그인해 주세요.
          </p>
          <!-- SNS 계정으로만 가입된 경우 - 네이버나 카카오 중 어떤 것인지 표시 -->
          <p v-else-if="!loginId && providers" class="guide_txt">
            해당 계정은 [{{ userProviders }}] 계정으로 가입되었습니다. <br />
            SNS 계정으로 로그인해 주세요.
          </p>
          <div class="find_id">{{ username }}</div>
        </li>
      </ul>
    </div>
    <div class="box">
      <div class="btn_wrap">
        <!-- <p class="guide_txt">
          {{ $t('views.auth.login.idfound.1123')
          }}<router-link to="/account"
            ><span class="fc_n">{{
              $t('views.auth.login.idfound.9459')
            }}</span> </router-link
          >{{ $t('views.auth.login.idfound.6674') }}
        </p> -->
        <router-link
          v-if="loginId || !providers"
          to="/login/password_lost"
          class="box_btn clr"
        >
          <span class="an_t">비밀번호 찾기</span>
        </router-link>
        <router-link to="/login" class="box_btn">
          <span class="an_t">로그인</span>
        </router-link>
      </div>
    </div>
  </LoginWrapper>
</template>
<script>
import LoginWrapper from '@/components/auth/LoginWrapper.vue'
export default {
  name: 'IdFound',
  components: { LoginWrapper },
  data() {
    return {
      providers: this.$route.params.providers,
      loginId: this.$route.params.email
    }
  },
  computed: {
    username() {
      return this.$route.params.email
    },
    userProviders() {
      const { providers } = this
      return providers.length === 2
        ? '카카오, 네이버'
        : providers.includes('kakao')
        ? '카카오'
        : providers.includes('naver')
        ? '네이버'
        : ''
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params.email && !to.params.providers) {
      next({ name: 'id_lost' })
    } else {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
.box_title {
  margin-bottom: 13px;
}
[data-detail*='id_search'] .text_wrap {
  margin-top: 0;
  p {
    font-size: 16px;
    color: #8b8b8b;
    font-weight: 600;
  }
}
.join_st .btn_wrap > p {
  text-align: center;
}
.join_st .btn_wrap .box_btn .an_t {
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 18px;
  line-height: 56px;
  letter-spacing: 0;
}
.btn_wrap {
  display: flex;
  justify-content: center;
  gap: 20px;
  .box_btn.clr {
    background-color: #fff;
    border: 1px solid #008df3;
    span {
      color: #008df3;
    }
  }
}
</style>
